<script context="module">
  import { DirectEncounterStatus } from "../../../Utils/utilEnums.svelte";

  export const DefaultCalendarTimeGridStartText = "T06:00:00";

  export const FullCalendarTitleFormats = {
    dayGridMonth: {
      year: "numeric",
      month: "long",
    },
    timeGridWeek: {
      year: "numeric",
      month: "long",
      day: "numeric",
    },
    timeGridDay: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "short",
    },
    listWeek: {
      year: "numeric",
      month: "long",
      day: "numeric",
    },
  };

  export const DefaultDateLocale = "en-AU";

  export const CalendarDisplayEncounterTypes = [
    DirectEncounterStatus.Active,
    DirectEncounterStatus.Cancelled,
    DirectEncounterStatus.OnHold,
    DirectEncounterStatus.PendingCancellation,
    DirectEncounterStatus.Archived,
  ];

  export const DefaultColumnWidthPx = 185;

  export const DailyPlannerSingleEventMaxHeightPx = 50;

  export const CalendarIdleRefreshIntervalSeconds = 120;
</script>
